import _trim from "lodash/trim";
import { mapState } from "vuex";
import { gtmTrack, gtmSaveCartTotal } from "@/util/gtm";

export default {
	data() {
		return {
			draft: "",
			price: ""
		};
	},
	computed: {
		...mapState({
			draftId: state => state.Step4.draftId
		})
	},
	created() {
		if (!this.areParamsValid()) {
			this.$router.replace({ name: "step1" });
			return;
		}

		if (!this.draftId) {
			this.showLoading();
			this.getSessionData();
		} else {
			this.hideLoading();
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.name == "step5") {
			const isMobileConfigurator = from.name == "step4-mobile";
			const build = isMobileConfigurator ? this.build : this.activeBuild;
			gtmTrack.buildConfiguration(build);
		}

		const buildPrice = this.$store.getters.buildPrice;
		if (buildPrice) {
			gtmSaveCartTotal(buildPrice);
		}
		next();
	},
	methods: {
		areParamsValid() {
			const MAX_PRICE_LENGTH = 4;

			const url = new URL(document.location.href);
			const price = _trim(url.searchParams.get("price")) || "";
			const draft = _trim(url.searchParams.get("draft")) || "";
			const priceIsOverflowed = price.length > MAX_PRICE_LENGTH;
			const hasBadParametersType = Number.isNaN(Number.parseInt(price)) || Number.isNaN(Number.parseInt(draft));

			if (!price || !draft || priceIsOverflowed || hasBadParametersType) {
				return false;
			}

			this.setParams(price, draft);

			return true;
		},
		getSessionData() {
			axios({
				url: `/details/${this.price}/${this.draft}?session=${CONFIG.SESSION}`,
				responseType: "json"
			}).then(response => {
				this.$store.dispatch("setBuildPrice", response.data.total);
				this.$store.dispatch("changeSessionDataInfo", response.data);
				this.$store.dispatch("changeSessionGamesData", response.data.fps);
				this.$store.dispatch("changeDraftId", response.data.draftId);
				this.$store.dispatch("setActiveBuild", response.data.defaultBuild);

				if (response.data.rules) {
					this.$store.dispatch("changeActiveRules", response.data.rules);
				}
			}).catch(() => {
				toastr.warning("We could not find your build, please create a new one.", "Build not found");
				this.$router.replace({ name: "step1" });
			}).finally(() => {
				this.hideLoading();
			});
		},
		setParams(price, draft) {
			this.price = price;
			this.draft = draft;
		}
	}
};
